import { useUserId } from "../../query/hooks/helpers";
import { useLocalStorage } from "./useLocalStorage";

export const useIsOnlyOneBusinessOwner = () => {
  const userId = useUserId();
  return useLocalStorage(`${userId}:is-only-one-business-owner`, true);
};
